import { mapActions } from 'vuex';
export default {
  data () {
    return {};
  },
  methods: {
    ...mapActions(['getPermisionItem']),
    initPermision () {
      const currentPath = this.$route.path;
      const menuCode = this.getMenuCode(currentPath);
      this.getPermisionItem(menuCode).then(res => {
        this.callBack && this.callBack(res);
      });
    },
    getMenuCode (path) {
      const index = path.lastIndexOf('/');
      const menuCode = path.slice(index + 1);
      return menuCode;
    }
  },
  mounted () {
    this.initPermision();
  }
};
